import { render, staticRenderFns } from "./FulfillmentDueColumn.vue?vue&type=template&id=76a9cc2e&"
import script from "./FulfillmentDueColumn.vue?vue&type=script&lang=js&"
export * from "./FulfillmentDueColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports